import { Quote } from "../../../Atoms/Icons";

// Placeholder quotes — swap in real employee testimonials before launch.
const testimonials = [
  { initials: "NP", quote: "I have been a part of VerdeMobility since its early days, when we started with AC chargers. I joined as a developer, and today, I have the opportunity to prove myself in a managerial role. What makes VerdeMobility special is its culture of trust, collaboration, and continuous learning — I've been given the freedom to take ownership, make decisions, and build a team where every individual feels valued, motivated, and empowered.", name: "Nikunj Patel", role: "Manager" },
  { initials: "NP", quote: "My experience at VerdeMobility has been a great part of my professional journey. The combination of challenging work, supportive people, and opportunities for growth has allowed me to develop significantly over the years. I look forward to continuing this journey, taking on new responsibilities, contributing to the team's success, and growing further as an engineer and a leader.", name: "Nishral Patel", role: "Senior Engineer III" },
  { initials: "MS", quote: "My journey from a Marketing & Events Intern to a Trainee Engineer has been shaped by curiosity, mentorship, and opportunities at VerdeMobility. The trust and guidance of experienced leaders helped me turn an academic project into a Gold Medal achievement and a career in Firmware Development. What makes VerdeMobility special for me is the people who recognise potential, encourage curiosity, and create opportunities to grow.", name: "Monark Sharma", role: "Trainee Engineer" },
];

export default function Testimonials() {
  return (
    <section className="py-10 lg:py-12">
      <div className="containers-min mx-auto px-4 py-8">
        <div className="text-center mb-10">
          {/* <p className="section-eyebrow mb-2">In Their Words</p> */}
          <h3 className="text-center font-gilroy">Employee Testimonials</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {testimonials.map((t) => (
            <div className="testimonial-card" key={t.initials}>
              <Quote className="quote-icon mb-3" size={26} />
              <p className="text-gray-600 mb-4 text-xl min-h-80">{t.quote}</p>
              <div className="flex items-center gap-3">
                <div className="testimonial-avatar">{t.initials}</div>
                <div>
                  <p className="mb-0 font-semibold text-lg">{t.name}</p>
                  <p className="mb-0 text-[var(--vm-text-gray)] text-sm">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
